import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, isRef as _isRef } from "vue"

const _hoisted_1 = { class: "app-wrapper" }
const _hoisted_2 = { class: "section-header" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "type-data" }
const _hoisted_8 = { class: "type-data" }
const _hoisted_9 = { class: "emq-table-footer" }

import ClockPriceingDrawer from '@/views/Pricing/components/ClockPriceingDrawer.vue'
import { getPriceingList, unusePriceing, getPriceingClock } from '@/api/operation'
import CommonPagination from '@/components/commonPagination.vue'
import useI18nTl from '@/hooks/useI18nTl'
import usePaginationRemember from '@/hooks/usePaginationRemember'
import usePaginationWithHasNext from '@/hooks/usePaginationWithHasNext'
import { Refresh, Plus } from '@element-plus/icons-vue'
import { pick } from 'lodash'
import AdosBrief from '@/components/AdosBrief.vue'
import { dateFormat, throttleBtn } from '@/common/tools'
import PriceingDrawer from '@/views/Pricing/components/PriceingDrawer.vue'
import PriceingUseAdo from '@/views/Pricing/components/PriceingUseAdo.vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { ClockingPriceingVer, PriceingInfo } from '@/types/types'
import { checkMenuShow } from '@/store/tool'
import LinkOperator from '@/components/Links/LinkOperator.vue'
import _ from 'lodash'


import { defineComponent, ref, defineExpose, defineProps, onMounted } from 'vue'

const __default__ = defineComponent({
  name: 'PricingTable',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  stationId: [String, Number],
  operatorId: {
    type: Number,
    required: false,
  },
  id: {
    type: Number,
    required: false,
  },
},
  setup(__props, { expose }) {

const props = __props

const { t, tl } = useI18nTl('Operation')
const PriceingDrawerRef = ref()
const showDialog = ref(false)
const editPriceingFlag = ref(false)
const showUseDialog = ref(false)
const showUsePriceing = ref<Partial<PriceingInfo>>()

const showClockDialog = ref<boolean>(false)
const editClockPriceingFlag = ref(false)
const showClockPriceingInfo = ref<Partial<ClockingPriceingVer>>()

const tableData = ref([])
const lockTable = ref(false)
const TableCom = ref()
const params = ref({})
const { pageMeta, pageParams, initPageMeta, setPageMeta, toPageMeta } = usePaginationWithHasNext()
const { updateParams } = usePaginationRemember('operators-detail')


const addPriceing = () => {
  showUsePriceing.value = {}
  editPriceingFlag.value = false
  showDialog.value = true
  PriceingDrawerRef.value?.clearValidate()
}
const editPriceing = (row: any) => {
  editPriceingFlag.value = showDialog.value = true
  showUsePriceing.value = _.cloneDeep(row) //深拷贝表格数据不跟着修改
}
const showClockPriceing = async (row: any) => {
  const { priceingVer }: { priceingVer: ClockingPriceingVer } = await getPriceingClock({
    priceingId: row.priceing.id,
  })
  showUsePriceing.value = _.cloneDeep(row)
  showClockPriceingInfo.value = priceingVer
  console.log('priceingVer', priceingVer)
  if (priceingVer.id.toString() == '0' || priceingVer.id.toString() == '') {
    editClockPriceingFlag.value = false
  } else {
    editClockPriceingFlag.value = true
  }
  showClockDialog.value = true
}
const usePriceingDialog = (row: any) => {
  showUsePriceing.value = row
  showUseDialog.value = true
}

const unuseAdo = async (priceingid: string, ado: any) => {
  if (!checkMenuShow('priceingUse')) {
    ElMessage.success(t('Base.permissionDenied'))
    return
  }
  try {
    await ElMessageBox.confirm(t('Base.confirmDelete'), {
      confirmButtonText: t('Base.confirm'),
      cancelButtonText: t('Base.cancel'),
      confirmButtonClass: 'confirm-danger',
      type: 'warning',
    })
    await unusePriceing({
      id: priceingid,
      unuse: ado,
    })
    ElMessage.success(t('Base.deleteSuccess'))
    loadPriceing()
    return Promise.resolve()
  } catch (error) {
    console.error(error)
    return Promise.reject()
  }
}

const tooltipContent = (row: { priceing: { id: string; desc: string; ver: string } }) => {
  return `<span></span>`
}

const loadPriceing = async () => {
  lockTable.value = true
  const { id, operatorId, stationId } = props
  const sendParams = {
    id: id || undefined,
    operatorId: operatorId || undefined,
    stationId: stationId || undefined,
    pageReq: {
      ...pageParams.value,
    },
  }

  try {
    const { prices = [], pageReply = {} } = await getPriceingList(sendParams)
    const meta = toPageMeta(sendParams.pageReq, pageReply)
    tableData.value = prices
    setPageMeta(meta)
    updateParams({ ...pick(meta, ['limit', 'page']), ...params.value })
  } catch (error) {
    tableData.value = []
    initPageMeta()
  } finally {
    lockTable.value = false
  }
}
const convertTimeSegment = (segment: number): string => {
  const hours = Math.floor(segment / 2)
  const minutes = (segment % 2) * 30
  const formattedHours = hours.toString().padStart(2, '0')
  const formattedMinutes = minutes.toString().padStart(2, '0')
  return `${formattedHours}:${formattedMinutes}`
}
const convertPriceing = (p1: number, p2: number) => {
  return (p1 + p2).toFixed(3)
}
const loadDatasRefreshLimit = throttleBtn(loadPriceing)
onMounted(() => {
  loadPriceing()
})
expose({
  loadPriceing,
})

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_role = _resolveDirective("role")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _withDirectives((_openBlock(), _createBlock(_component_el_button, {
        type: "primary",
        icon: _unref(Plus),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (addPriceing()))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('Base.create')), 1)
        ]),
        _: 1
      }, 8, ["icon"])), [
        [_directive_role, 'priceingUpsert']
      ]),
      _createVNode(_component_el_button, {
        type: "primary",
        plain: "",
        icon: _unref(Refresh),
        onClick: _unref(loadDatasRefreshLimit)
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('Base.refresh')), 1)
        ]),
        _: 1
      }, 8, ["icon", "onClick"])
    ]),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      data: tableData.value,
      ref_key: "TableCom",
      ref: TableCom,
      "row-key": "id"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "id",
          "min-width": "80",
          fixed: "",
          label: _ctx.$t('Base.name'),
          "show-overflow-tooltip": "",
          align: "center"
        }, {
          default: _withCtx(({ row }) => [
            _createVNode(_component_el_tooltip, { placement: "top" }, {
              content: _withCtx(() => [
                _createElementVNode("div", null, [
                  _createElementVNode("div", null, "ID: " + _toDisplayString(row.priceing.id), 1),
                  _createElementVNode("div", null, "Ver: " + _toDisplayString(row.priceing.ver), 1),
                  _createElementVNode("div", null, _toDisplayString(row.priceing.desc), 1)
                ])
              ]),
              default: _withCtx(() => [
                (_unref(checkMenuShow)('priceingUpsert'))
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 0,
                      type: "text",
                      onClick: ($event: any) => (editPriceing(row))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(row.priceing.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(row.priceing.name), 1))
              ]),
              _: 2
            }, 1024)
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          "min-width": "50",
          label: _ctx.$t('Operation.operator')
        }, {
          default: _withCtx(({ row }) => [
            _createVNode(LinkOperator, {
              id: row.operator.id,
              name: row.operator.name
            }, null, 8, ["id", "name"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          "min-width": "80",
          label: _ctx.$t('Operation.priceing')
        }, {
          default: _withCtx(({ row: { priceing } }) => [
            (priceing.elecTariffs && priceing.elecTariffs.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(priceing.elecTariffs, (tariff) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: tariff.tag,
                      class: "tariff-row"
                    }, [
                      _createElementVNode("div", null, _toDisplayString(convertTimeSegment(tariff.timeStart)) + "~" + _toDisplayString(convertTimeSegment(tariff.timeEnd)) + " (" + _toDisplayString(_ctx.$t('Evses.Einheit')) + _toDisplayString(convertPriceing(tariff.price, tariff.servicePrice)) + ") ", 1)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (priceing.chargingTimeTariffs && priceing.chargingTimeTariffs.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(priceing.chargingTimeTariffs, (chargingTime, idx) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: chargingTime.price + idx,
                      class: "tariff-row"
                    }, [
                      _createElementVNode("div", null, _toDisplayString(chargingTime.powerStart) + "W ~" + _toDisplayString(chargingTime.powerEnd) + "W (" + _toDisplayString(_ctx.$t('Evses.Einheit')) + _toDisplayString(convertPriceing(chargingTime.price, chargingTime.servicePrice)) + ") ", 1)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          "min-width": "80",
          label: _ctx.$t('Operation.uses')
        }, {
          default: _withCtx(({ row }) => [
            _createVNode(AdosBrief, {
              ados: row.uses,
              objid: row.priceing.id,
              colse: unuseAdo
            }, null, 8, ["ados", "objid"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          "min-width": "80",
          label: _ctx.$t('Operation.lastRelease')
        }, {
          default: _withCtx(({ row }) => [
            _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(dateFormat)(Number(row.priceing.createdAt) * 1000)), 1)
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          prop: "create",
          "min-width": "80",
          label: _ctx.$t('Base.create')
        }, {
          default: _withCtx(({ row }) => [
            _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(dateFormat)(Number(row.createdAt) * 1000)), 1)
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          label: _ctx.$t('Base.operation'),
          "class-name": "table-operation"
        }, {
          default: _withCtx(({ row }) => [
            _withDirectives((_openBlock(), _createBlock(_component_el_button, {
              size: "small",
              plain: "",
              onClick: ($event: any) => (editPriceing(row))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('Base.edit')), 1)
              ]),
              _: 2
            }, 1032, ["onClick"])), [
              [_directive_role, 'priceingUpsert']
            ]),
            _withDirectives((_openBlock(), _createBlock(_component_el_button, {
              size: "small",
              plain: "",
              onClick: ($event: any) => (usePriceingDialog(row))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('Base.use')), 1)
              ]),
              _: 2
            }, 1032, ["onClick"])), [
              [_directive_role, 'priceingUse']
            ]),
            _withDirectives((_openBlock(), _createBlock(_component_el_button, {
              size: "small",
              plain: "",
              onClick: ($event: any) => (showClockPriceing(row))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('Operation.clockingPriceing')), 1)
              ]),
              _: 2
            }, 1032, ["onClick"])), [
              [_directive_role, 'priceingUpsert']
            ])
          ]),
          _: 1
        }, 8, ["label"])
      ]),
      _: 1
    }, 8, ["data"])), [
      [
        _directive_loading,
        lockTable.value,
        void 0,
        { lock: true }
      ]
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(CommonPagination, {
        metaData: _unref(pageMeta),
        "onUpdate:metaData": _cache[1] || (_cache[1] = ($event: any) => (_isRef(pageMeta) ? (pageMeta).value = $event : null)),
        onLoadPage: loadPriceing
      }, null, 8, ["metaData"])
    ]),
    _createVNode(PriceingUseAdo, {
      modelValue: showUseDialog.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((showUseDialog).value = $event)),
      priceingID: String(showUsePriceing.value?.priceing?.id ?? ''),
      operator: (showUsePriceing.value && showUsePriceing.value.operator) ?? {},
      onSubmitted: loadPriceing
    }, null, 8, ["modelValue", "priceingID", "operator"]),
    _createVNode(PriceingDrawer, {
      ref_key: "PriceingDrawerRef",
      ref: PriceingDrawerRef,
      modelValue: showDialog.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((showDialog).value = $event)),
      isEdit: editPriceingFlag.value,
      priceingInfo: showUsePriceing.value,
      onSubmitted: loadPriceing,
      stationId: props.stationId,
      operatorId: props.operatorId
    }, null, 8, ["modelValue", "isEdit", "priceingInfo", "stationId", "operatorId"]),
    _createVNode(ClockPriceingDrawer, {
      ref_key: "PriceingDrawerRef",
      ref: PriceingDrawerRef,
      modelValue: showClockDialog.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((showClockDialog).value = $event)),
      isEdit: editClockPriceingFlag.value,
      priceingInfo: showUsePriceing.value,
      priceingClockInfo: showClockPriceingInfo.value,
      onSubmitted: loadPriceing,
      stationId: props.stationId,
      operatorId: props.operatorId
    }, null, 8, ["modelValue", "isEdit", "priceingInfo", "priceingClockInfo", "stationId", "operatorId"])
  ]))
}
}

})